import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const partnerHostedCardOnboardingActions = createDataModuleActions(
    'PARTNER_HOSTED_CARD_APPLICATION',
);
export const fetchPartnerHostedCardApplication =
    partnerHostedCardOnboardingActions.dataRequest;
export const fetchPartnerHostedCardApplicationSuccess =
    partnerHostedCardOnboardingActions.dataSuccess;
export const fetchPartnerHostedCardApplicationError =
    partnerHostedCardOnboardingActions.dataError;
export const fetchPartnerHostedCardApplicationReset =
    partnerHostedCardOnboardingActions.dataReset;
